// extracted by mini-css-extract-plugin
export default {"wrapper":"LogMsgTable_wrapper__mzLjS","inner":"LogMsgTable_inner__nk3Sp","msgStart":"LogMsgTable_msgStart__PbOm+"};